import { render, staticRenderFns } from "./ChildOption.vue?vue&type=template&id=23ca4ad1&"
import script from "./ChildOption.vue?vue&type=script&lang=js&"
export * from "./ChildOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ca4ad1')) {
      api.createRecord('23ca4ad1', component.options)
    } else {
      api.reload('23ca4ad1', component.options)
    }
    module.hot.accept("./ChildOption.vue?vue&type=template&id=23ca4ad1&", function () {
      api.rerender('23ca4ad1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/header/ChildOption.vue"
export default component.exports